import React, { useState } from "react";
import { Dialog, DialogContent, DialogTitle, Button } from "@mui/material";

function Copyright() {
  const [open, setOpen] = useState(false);

  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);

  return (
    <footer
      style={{
        backgroundColor: "#7C2EA0",
        color: "#fff",
        fontSize: "12px",
        textAlign: "center",
        boxSizing:"border-box",
        padding: "8px",
        position: "fixed",
        bottom: 0,
        width: "100%",
        zIndex: 7,
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
      }}
    >
      <div style={{ flexGrow: 1, textAlign: "center" }}>
        <Button 
          variant="outlined" 
          color="inherit" 
          onClick={handleOpen}
          style={{ color: "white", borderColor: "white", fontSize:"10px" }}
        >
          View Workflow Process
        </Button>
      </div>
      {/* <div style={{ marginLeft: "auto", textAlign: "right" }}>© {new Date().getFullYear()} Pairbytes. All rights reserved.</div> */}

      {/* Modal to show process image */}
      <Dialog open={open} onClose={handleClose} maxWidth="lg" fullWidth style={{zIndex:"9999999"}}>
        <DialogTitle>Workflow Process</DialogTitle>
        <DialogContent style={{ display: "flex", justifyContent: "center", padding: "16px" }}>
          <img
            src="./process1.png"
            alt="Workflow Process"
            style={{ maxWidth: "100%", maxHeight: "70vh", objectFit: "contain" }}
          />
          
        </DialogContent>
        <div style={{ display: 'flex', alignSelf: 'center' }}>
                    
                    <Button
                      variant="contained"
                      color="error"
                      onClick={handleClose}
                      sx={{
                        mt: 2,
                        alignSelf: 'center',
                        width: '150px', marginBottom:"20px"
                      }}
                    >
                      Close
                    </Button>
                  </div>
      </Dialog>
    </footer>
  );
}

export default Copyright;
